module.exports = __webpack_public_path__ + "static/media/lp_ic_a.08bea8bb.svg";